import { Literal, Record, String, Union, Boolean } from "runtypes";
import { ValidDidVerificationStatus, DidVerificationStatus } from "../../../did/verifier";
/**
 * IDVC verification status
 */
export var ValidIDVCVerificationStatus = Record({
    status: Literal("VALID"),
    didVerificationResult: ValidDidVerificationStatus,
    idvcVerificationResult: Literal(true),
    idvcRevokedStatus: Literal(false),
    issuerId: String,
    idvcBoundId: String,
    key: String,
});
export var InvalidIDVCVerificationStatus = Record({
    status: String,
    didVerificationResult: DidVerificationStatus,
    idvcVerificationResult: Boolean,
    idvcRevokedStatus: Boolean,
    issuerId: String,
    idvcBoundId: String,
    key: String,
});
export var IDVCVerificationStatus = Union(ValidIDVCVerificationStatus, InvalidIDVCVerificationStatus);
